import ReactGA from "react-ga4";

type ChatGAEventParams = Record<string, boolean | number | string | undefined>;

const chatEvents = {
  open_ai_agent_chat: {
    category: "Chat IA",
    action: "Abertura do chat",
    label: "open_ai_agent_chat",
  },
  close_ai_agent_chat: {
    category: "Chat IA",
    action: "Fechamento do chat",
    label: "close_ai_agent_chat",
  },
  message_sent_to_ai_agent: {
    category: "Chat IA",
    action: "Envio de mensagem para o agente de IA",
    label: "message_sent_to_ai_agent",
  },
  ai_agent_chat_link_click: {
    category: "Chat IA",
    action: "Clique em link no chat",
    label: "ai_agent_chat_link_click",
  },
  link_displayed_by_ai_agent: {
    category: "Chat IA",
    action: "Exibição de link pela IA",
    label: "link_displayed_by_ai_agent",
  },
};

export type ChatGAEvent = keyof typeof chatEvents;

export function trackGAEvent(event: ChatGAEvent, params?: ChatGAEventParams) {
  if (!ReactGA.isInitialized) return;

  ReactGA.event(event, {
    nonInteraction: true,
    transport: "xhr",
    ...chatEvents[event],
    ...params,
  });
}
